
import Popup from 'vux/src/components/popup/index.vue'

import SelectDialog from './../../components/formulaComponent/selectDialog'
import UnitDialog from './../../components/formulaComponent/unitDialog'
import filterJson from './../../utils/filter/filter'
export default {
props: {
/** select 类型 弹框列表数据 */
dataList: {
type: Array,
default: () => []
},
/** 所有类型 左侧文案 */
title: {
type: String
},
/** select类型 弹框的标题 */
dialogTitle: {
type: String
},
/** 所有类型 双向绑定的数值 */
value: {
type: String
},
/** 所有类型 是否可以点击 */
disabled: {
type: Boolean
},
/** 所有类型 当disabled为true时，展示的样式 */
customStyle: { // gray
type: String
},
/** 所有类型 左侧标题点击时popover的展示内容 */
clickData: {
type: String
},
/** 所有类型 左侧标题点击时dialog的展示内容  目前此功能运营说舍弃 */
clickPage: {
type: String
},
/** 所有类型  输入框的类型 */
type: {
type: String
},
/** number类型 最小值 */
max: {
type: String
},
/** number类型 最小值 */
min: {
type: String
},
/** popover 弹框的位置 */
popoverPosition: {
type: String
},
/** select类型 弹框每一条的样式
* showScore - 显示每个选项的分数
*/
itemStyle: {
type: String
},
/**  number 类型的 单位列表 对应的key 值
*/
units: {
type: String
},
/**  number 类型的 单位列表 对应的 index 值
*/
unitIndex: {
type: Number
},
/**  number 类型的 单位列表 基础计算单位的下标
*/
unitBaseScaleIndex: {
type: Number,
default: 0
}
},
components: {
Popup,
SelectDialog,
UnitDialog
},
data () {
return {
myValue: this.value,
showPopup: false,
isShowSelectDialog: false,
selectTxtValue: '',
clickElementClientY: 0,
selectTitle: this.dialogTitle || this.title,
isFit: true,
hasMoreItem: true,

unitSelectIndex: 0,
showUnitDesc: false,
numValue: this.value,
isShowUnitDialog: false

}
},
created () {
let self = this
console.log(self.popoverPosition)
console.log(self.dataList, self.myValue)
for (let i = 0; i < self.dataList.length; i++) {
if (self.myValue == self.dataList[i].value) {
self.selectTxtValue = self.dataList[i].name
console.log(self.selectTxtValue)
break
}
}

/* if (self.units) {
let list = filterJson[self.units]||[]
self.unitsList = list
if (self.unitsList.length<=self.unitIndex) {
self.unitSelectIndex = 0
} else {
self.unitSelectIndex = self.unitIndex || 0
}
} */
},
methods: {
/** 每行的点击事件 */
itemClick (event) {
let self = this
let type = this.type
if (self.disabled) {
return false
} else {
switch (type) {
case 'checkbox':
self.changeFun()
break
case 'select':
self.changeSelectFun(event)
break
case 'number':
self
.break

default:
break
}
}
},

changeFun (type) {
if (this.myValue == '1') {
this.myValue = '0'
} else {
this.myValue = '1'
}
},
/** 此功能隐藏 */
showDialogPage () {
console.log(11)
let self = this

},
/** type 为 number 类型  input方法 */
changeNum (val) {
let self = this

let t = val.charAt(0)

val = val.replace(/[^\d.]/g, '')

val = val.replace(/^\./g, '')

val = val.replace(/\.{2,}/g, '.')

val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')

if (t == '-') {
val = '-' + val
}
self.numValue = val

console.log('val', val)

if (self.unitsList.length > 0) {
let index = self.unitSelectIndex || 0
let max = self.unitsList[index].max
let min = self.unitsList[index].min



if (max && max && (Number(val) > max || Number(val) < min)) {
self.isFit = false
self.myValue = '---'
} else if (max && Number(val) > max) {
self.isFit = false
self.myValue = '---'
} else if (min && Number(val) < min) {
self.isFit = false
self.myValue = '---'
} else {
console.log(4)
self.isFit = true
if (self.unitsList[index].baseNum) {
console.log(self.unitsList[index].baseNum, 'self.unitsList[index].baseNum')
let scale = self.unitsList[index].scale / self.unitsList[self.unitBaseScaleIndex].scale
console.log(self.unitBaseScaleIndex)
console.log(scale)
self.myValue = String((val - self.unitsList[index].baseNum) / scale)
} else {
let scale = self.unitsList[index].scale / self.unitsList[self.unitBaseScaleIndex].scale
console.log(self.unitBaseScaleIndex)
console.log(scale)
self.myValue = String(val / scale)
}
}
} else {
let max = self.max
let min = self.min
console.log(max)
console.log(min)
console.log(Number(val))
if (max && max && (Number(val) > max || Number(val) < min)) {
self.isFit = false
console.log(11)
self.myValue = '---'
} else if (max && Number(val) > max) {
self.isFit = false
self.myValue = '---'
console.log(21)
} else if (min && Number(val) < min) {
self.isFit = false
self.myValue = '---'
console.log(31)
} else {
console.log(41)
self.isFit = true
self.myValue = String(val)
}
}
console.log(self.myValue)
},
/** type 为 number 类型 单位切换 */
changeUnit () {
let self = this
self.isShowUnitDialog = true
},
inputNumberFocuse () {
let self = this
self.showUnitDesc = true
},
inputNumberBlur () {
let self = this
self.showUnitDesc = false
},
changeSelectFun (event) {
console.log(event)


this.clickElementClientY = this.$refs.itemsDom.offsetTop + this.$refs.itemsDom.offsetHeight - 10


this.isShowSelectDialog = true
},
showPopover (event) {
event.stopPropagation()
event.preventDefault()
console.log(event)
console.log(this.$refs.medicalEditor_info.classList)
let myPopoverArr = document.getElementsByClassName('medicalEditor_my-popover') || []
console.log(myPopoverArr, '气泡伪数组')
if (this.$refs.medicalEditor_info.classList.contains('divBlock')) {

for (let popIndex = 0; popIndex < myPopoverArr.length; popIndex++) {
myPopoverArr[popIndex].classList.remove('divBlock')
}
} else {

for (let popIndex = 0; popIndex < myPopoverArr.length; popIndex++) {
myPopoverArr[popIndex].classList.remove('divBlock')
}
this.$refs.medicalEditor_info.classList.add('divBlock')
}
},
getSelecDialogState (data) {
this.isShowSelectDialog = data
},
setSelectValue (data) {
this.myValue = data.value
this.selectTxtValue = data.shortName ? data.shortName : data.name
},
getUnitDialogState (data) {
this.isShowUnitDialog = data
},
setUintSelectValue (data) {
console.log(data)
let self = this
self.unitSelectIndex = data
self.changeNum(self.numValue)

}
},
computed: {
activeClass () {
if (this.disabled && this.customStyle) {
return 'formula-item-' + this.customStyle
} else if ((!this.disabled) && this.customStyle) {
return 'formula-item-blue'
} else {
return ''
}
},
unitsList () {
let self = this
let list = []
if (self.units) {
list = filterJson[self.units] || []
if (list.length <= self.unitIndex) {
self.unitSelectIndex = 0
} else {
self.unitSelectIndex = self.unitIndex || 0
}
}
return list
}
},
watch: {

value (newVal) {
this.myValue = newVal
},


myValue (newVal) {
this.$emit('input', newVal)
}
}

}



// WEBPACK FOOTER //
// ./src/components/formulaComponent/formulaLabelSelect.vue